
import { Component, Mixins, Prop } from "vue-property-decorator";
import { MasterSelectableMixin } from ".";

@Component({
})
export default class FilterableMasterSelectableMixin extends Mixins(MasterSelectableMixin) {
  @Prop()
  filter: (source: any) => boolean;
}
